
































import Vue from 'vue';
import { mapActions, mapMutations } from 'vuex';
import { BDropdown, BDropdownItemButton, BButton } from 'bootstrap-vue';
import { MetricOptions } from '@/constants/DashboardConstants';
import { Question } from '@/state/modules/survey_builder/state';

const sortByLabel = (a, b) => a.label.localeCompare(b.label);

export default Vue.extend({
  name: 'QuestionEditMapping',
  components: {
    BDropdown,
    BDropdownItemButton,
    BButton,
  },
  props: {
    question: {
      type: Object as () => Question,
      required: true,
    },
  },
  data() {
    return {
      mappings: {},
    };
  },
  computed: {
    newMenu() {
      return ['Task', 'Control'];
    },
    metrics() {
      let currentMetrics = [];
      currentMetrics = Object.values(MetricOptions)
        .map(v => ({ value: v.model, label: v.label }))
        .sort(sortByLabel);
      const mappings = Object.keys(this.mappings);
      return currentMetrics.filter(i => i.value !== 'SurveyResponse' && !mappings.find(m => m === i.value));
    },
    flatMappings() {
      return Object.values(this.mappings).flat();
    },
  },
  mounted() {
    this.initMappings();
  },
  methods: {
    ...mapActions({
      showModal: 'modals/show',
      showAlert: 'alerts/show',
    }),
    ...mapMutations({
      setQuestionMapping: 'surveyBuilder/SET_QUESTION_MAPPINGS',
    }),
    initMappings() {
      this.mappings = this.question.mappings.reduce((acc, value) => {
        if (!acc[value.type]) {
          acc[value.type] = [];
        }
        acc[value.type].push(value);
        return acc;
      }, {});
    },
    async addNewMapping(objectType) {
      try {
        const mappings = await this.showModal({
          type: 'ObjectMapperModal',
          data: {
            rightType: objectType.value,
          },
        });

        if (mappings.length) {
          mappings.forEach(m => {
            m.type = objectType.value;
          });
          this.$set(this.mappings, objectType.value, mappings);
          this.setQuestionMapping({ questionId: this.question.id, mappings: this.flatMappings });
        }
      } catch (e) {
        // User closed modal
      }
    },
    async openMappings(objectType, items) {
      try {
        const mappings = await this.showModal({
          type: 'ObjectMapperModal',
          data: {
            rightType: objectType,
            mappings: items,
          },
        });

        if (mappings.length) {
          mappings.forEach(m => {
            m.type = objectType;
          });
          this.$set(this.mappings, objectType, mappings);
        } else if (this.mappings[objectType]) {
          delete this.mappings[objectType];
          this.mappings = { ...this.mappings };
        }

        this.setQuestionMapping({ questionId: this.question.id, mappings: this.flatMappings });
      } catch (e) {
        // User closed modal
      }
    },
  },
});
